export default __webpack_public_path__ + "static/media/masteringBG.c39def3e.webp";